import { HeaderIcon, NaviIconHome } from '@banhala/ui-kit';
import { useNavigator } from '../../utils';
import { useCallback } from 'react';

type Props = {
  logClickHome?: () => void;
  backgroundColor?: 'white' | 'transparent';
};

export const HomeIcon = ({ backgroundColor, logClickHome }: Props) => {
  const { navigator } = useNavigator();
  const handleHomeClick = useCallback(() => {
    navigator.moveToHome();
    logClickHome?.();
  }, [logClickHome, navigator]);

  return (
    <HeaderIcon
      testID={'홈버튼'}
      onPress={handleHomeClick}
      backgroundColor={backgroundColor}
    >
      <NaviIconHome />
    </HeaderIcon>
  );
};
